import { MdText } from '@ui/components/MdText';
import { ModalCard } from '@ui/components/ModalCard';
import { ThemeButton } from '@ui/components/ThemeButton';

import { CLUB_RULES } from '../constants';

import styles from './ClubRulesModal.module.css';

type Props = {
  onClose: () => void;
  onConsent?: () => void;
  isPending?: boolean;
};

export function ClubRulesModal({ onClose, onConsent, isPending }: Props) {
  return (
    <ModalCard
      className={styles.card}
      title="Правила клуба"
      onClose={isPending ? undefined : onClose}
    >
      <div className={styles.body}>
        <MdText value={CLUB_RULES.text} />
      </div>
      {onConsent && (
        <div className={styles.buttons}>
          <ThemeButton disabled={isPending} onClick={onConsent}>
            Принимаю
          </ThemeButton>
          <ThemeButton inverted disabled={isPending} onClick={onClose}>
            Не принимаю
          </ThemeButton>
        </div>
      )}
    </ModalCard>
  );
}
